import { render, staticRenderFns } from "./TopOffenders.vue?vue&type=template&id=6424937c&"
import script from "./TopOffenders.vue?vue&type=script&lang=js&"
export * from "./TopOffenders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports